import { baseUrl } from "../utils";

export type CommonOptions = {
  RADIUS: 300;
  GLOBE_SEGMENTS: number;
  CAMERA_FAR: number; // RADIUS * 100
  CAMERA_FOV: number;
  CAMERA_NEAR: number;
};

export const commonOption: CommonOptions = {
         RADIUS: 300,                                   // 球大小
         CAMERA_FAR: 300 * 1000, // RADIUS * 100         // 相机位置
         CAMERA_FOV: 45,
         CAMERA_NEAR: 1,
         GLOBE_SEGMENTS: 100,
       };
export type XYZ = {
  x: number;
  y: number;
  z: number;
}
type ModeOption = {
  transparent: boolean
  cameraPosition: XYZ,
  cameraLookAt: XYZ
}

export type ResourcesOptions = {
  mountainModel: string;
  mountainTextureTop: string;
  mountainTextureBody: string;
  mountainMaskTop: string;
  mountainMaskBody: string;
  cloudTexture: string;

  tweenDuration: number;
  modes: ModeOption[];
};

const mountainsOptions: ResourcesOptions = {
  mountainModel: `${baseUrl}/center.001.obj`,
  mountainTextureTop: `${baseUrl}/core7.png`,
  mountainTextureBody: `${baseUrl}/center7.png`,
  mountainMaskTop: `${baseUrl}/coremask.png`,
  mountainMaskBody: `${baseUrl}/centermask.png`,
  cloudTexture: `${baseUrl}/cl1.png`,

  tweenDuration: 1200,
  modes: [
    { // aod
      transparent: true,
      cameraPosition: {x: 20, y: -80, z: -15},
      cameraLookAt: {x: 5, y: -2, z: -4},
    },
    { // lock
      transparent: false,
      cameraPosition: {x: -3, y: -19, z: -2},
      cameraLookAt: {x: 1, y: 0, z: -2},
    },
    { // home
      transparent: false,
      cameraPosition: {x: -12, y: -25, z: -2},
      cameraLookAt: {x: 1, y: 0, z: -2},
    },
    { // lock
      transparent: false,
      cameraPosition: { x: -3, y: -19, z: -2 },
      cameraLookAt: { x: 1, y: 0, z: -2 },
    },
  ],
};

export const mars = mountainsOptions;
